module.exports = __webpack_public_path__ + "img/tabs.ec7f47ba.png";